import { makeStyles } from '@material-ui/styles';
import React, { useContext, useState } from 'react';
import { NavLink, useHistory, useParams, useLocation } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { getFullDate } from '../../../utils/dateTimeUtil';
import MessagesContext from '../../../contexts/messagesContext';
import {
    isDeletingFormEntry,
    deleteFormEntry
} from '../../../redux/DynamicForms/DynamicFormsAction';
import { useDispatch, useSelector } from 'react-redux';
import { AlertDialog, Options } from '../../UI';
import useCheckMobileScreen from '../../../hooks/useWidth';
import useCheckAccess from '../../../hooks/useCheckAccess';

const styles = makeStyles((theme) => ({
    cardContainer: {
        marginBottom: '16px',
        display: 'flex',
        position: 'relative',
        direction: 'rtl'
    },
    linkContainer: {
        padding: '8px 16px 12px 16px',
        borderRadius: '4px',
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)',
        border: 'solid 1px #e8ecf2',
        backgroundColor: '#fff',
        minHeight: '51px',
        width: '100%',
        [theme.breakpoints.down(1025)]: {
            boxShadow: 'unset',
            borderRadius: '4px'
        }
    },
    activeCard: {
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)',
        border: 'solid 1px #509ffa',
        backgroundColor: '#e3f0ff'
    },
    date: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    formName: {
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: '600',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.54',
        letterSpacing: 'normal',
        textAlign: 'start',
        unicodeBidi: 'plaintext',
        color: '#232733',
        wordWrap: 'wrap'
    },
    row: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: '6px'
    },
    badge: {
        width: '38px',
        height: '17px',
        borderRadius: '16px',
        backgroundColor: '#416ce1',
        fontFamily: 'inherit',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.7',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#fff'
    }
}));

const FormCard = ({
    items: { structure, id, created, title },
    path,
    isComparison = false,
    isNew = false
}) => {
    const classes = styles();
    const isMobile = useCheckMobileScreen();
    const { messages } = useContext(MessagesContext);
    const [openAlert, setOpenAlert] = useState(false);
    const history = useHistory();
    const params = useParams();
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const { notEditClinical } = useCheckAccess();
    const url = `/${params.clinicId}/patient/${params?.id}/forms/form`;
    const cardId = pathname?.split('/').filter((item) => item)[5];
    const allForms = useSelector((state) => state.dynamicForms.allForms);
    const options = [
        // { label: messages.edit, icon: 'edit', value: 0 },

        { label: messages.delete, icon: 'delete', value: 1 },
        { label: messages.comparison, icon: 'comparison', value: 2 }
    ];
    // const handleGetEntry = () => {
    //     dispatch(getFormStructureNew(structure?.name));
    // };
    const handleDeleteForm = async () => {
        await dispatch(isDeletingFormEntry(true));
        dispatch(deleteFormEntry(structure?.name, +id));
        // if (entries.length <= 1) {
        //     history.replace(`${url}/newForm`);
        // } else {
        setOpenAlert(false);
        if (isMobile) {
            return;
        } else if (+cardId === id) {
            history.replace(`${url}/newForm`);
        }
        dispatch(isDeletingFormEntry(false));
        // }
    };

    const handleSelectOptions = (option) => {
        if (option?.value === 0) {
            // handleGetEntry();
            history.push(path);
        } else if (option?.value === 1) {
            // handleDeleteForm();
            setOpenAlert(true);
        } else if (option?.value === 2) {
            if (allForms) {
                const firstFormName = allForms[0]?.name;
                history.push(
                    `/${params.clinicId}/patient/${params?.id}/forms/comparison/${firstFormName}`
                );
            }
        }
    };

    return (
        <>
            <AlertDialog
                open={openAlert}
                alertText={messages.alerts.deleteFormEntryNew}
                cancelText={messages.cancel}
                confirmText={messages.delete}
                handleAction={handleDeleteForm}
                handleClose={() => setOpenAlert(false)}
            />
            <div className={classes.cardContainer}>
                {isNew || isComparison ? null : (
                    <Options
                        top={5}
                        right={16}
                        width={'20px'}
                        options={options}
                        handleSelect={handleSelectOptions}
                        disabled={notEditClinical}
                    />
                )}

                <NavLink
                    to={{
                        pathname: path,
                        state: { isNew: false }
                    }}
                    data-testid="formCard"
                    // onClick={handleGetEntry}
                    activeClassName={classes.activeCard}
                    className={`${isNew && classes.activeCard} ${classes.linkContainer}`}
                >
                    <div className={classes.row}>
                        {isNew && <div className={classes.badge}>{messages.new}</div>}

                        <div className={classes.date}>
                            <span>{getFullDate(created)}</span>
                        </div>
                    </div>
                    <div className={classes.formName}>{structure?.title || title}</div>
                </NavLink>
            </div>
        </>
    );
};
FormCard.propTypes = {
    items: PropTypes.object,
    path: PropTypes.string,
    isComparison: PropTypes.bool,
    isNew: PropTypes.bool
};

export default FormCard;
